<template>
  <div id="welcome-screen" aria-live="polite">
    <h2>Olá, {{ $store.state.main.candidateInfo.firstName }}!</h2>
    <p class="welcome-description">Navegue através do menu lateral para acessar suas provas, requerimentos e certificados</p>
  
    <div v-if="qrValue">
      <p>Para logar no app, escaneie o qrcode abaixo:</p>
      <qrcode-vue 
        :value="qrValue" 
        size="400"
        level="H"
        render-as="svg"
        background="#ffffff"
        foreground="#000000"
      />
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import {getCookie} from "../../scripts/utils";
import {getBaseSgpUrl} from "../../scripts/apiService/ApiService";

export default {
  name: 'WelcomeScreen',
  components: {
    QrcodeVue
  },
  data: () => { return {
    qrValue: null
  }},
  mounted() {
    let mustShowQr = this.$store.state.main.candidateInfo.availableMenus.qr_login;
    if (!mustShowQr) return;

    let token = getCookie("candidateToken");
    let key = getCookie("currentCandidate");
    let domain = getBaseSgpUrl();
    let refresh = getCookie("refreshToken");
    if (token && key && refresh) {
      let resultDict = {
        "token": token,
        "key": key,
        "url": domain,
        "refresh": refresh
      }
      this.qrValue = btoa(JSON.stringify(resultDict));
    }
  }
}
</script>
